import AddTailoredExperienceEventsToCalendarJsonResponse from 'owa-service/lib/contract/AddTailoredExperienceEventsToCalendarJsonResponse';
import addTailoredExperienceEventsToCalendarOperation from 'owa-service/lib/operation/addTailoredExperienceEventsToCalendarOperation';
import ItemId from 'owa-service/lib/contract/ItemId';
import itemId from 'owa-service/lib/factory/itemId';
import addTailoredExperienceEventsToCalendarRequest from 'owa-service/lib/factory/addTailoredExperienceEventsToCalendarRequest';
import addTailoredExperienceEventsToCalendarJsonRequest from 'owa-service/lib/factory/addTailoredExperienceEventsToCalendarJsonRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { trace } from 'owa-trace';
import { format } from 'owa-strings';

/**
 *
 * This function makes the EWS service call to add Txp events to calendar
 *
 */
export default function addTxpEventsToCalendar(
    itemid: string
): Promise<AddTailoredExperienceEventsToCalendarJsonResponse> {
    let itemBody: ItemId = { Id: itemid };
    let itemIdBody = { ItemIds: [itemId(itemBody)] };

    return addTailoredExperienceEventsToCalendarOperation(
        addTailoredExperienceEventsToCalendarJsonRequest({
            Header: getJsonRequestHeader(),
            Body: addTailoredExperienceEventsToCalendarRequest(itemIdBody),
        })
    )
        .then(response => response)
        .catch(error => {
            trace.error(
                format('[TXP] Error when calling AddTxpEventsToCalendar EWS API, error: {0}', error)
            );
            return null;
        });
}
